import { SecurityGuard } from './guard';

export function SecurityGuardFactory(): SecurityGuard {
  return new SecurityGuard();
}
